import { LOAD_USERS } from '../../constant';

const initialState = [];

const users = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_USERS:
      return [...action.payload];
    default:
      return state;
  }
};

export default users;
